export const GetColumnClassName = (col = []) => {
    switch (col.length) {
        case 1:
            return `col-${col[0]} col-xs-${col[0]} col-md-${col[0]} col-lg-${col[0]}`
        case 2:
            return `col-${col[0]} col-xs-${col[0]} col-md-${col[1]} col-lg-${col[0]}`
        case 3:
            return `col-${col[0]} col-xs-${col[0]} col-md-${col[1]} col-lg-${col[2]}`
        default:
            return `col-12 col-xs-12 col-md-12 col-lg-12`
    }
}